import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-bg">
        <div className="hero-gradient"></div>
        <div className="hero-pattern"></div>
      </div>

      <div className="container">
        <div className="hero-content-centered">
          <motion.div
            className="hero-badge"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.1 }}
          >
            <span className="badge-dot"></span>
            <span>AI-augmented QA — real expertise, real results</span>
          </motion.div>

          <motion.h1
            className="hero-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            QA Services for <span className="gradient-text">Small Companies</span>
          </motion.h1>

          <motion.p
            className="hero-subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            20+ years of QA leadership, now available to small companies. Fixed-price audits and Playwright test suites — no retainer, no fluff, just coverage that works.
          </motion.p>

          <motion.div
            className="hero-actions"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <a
              href="mailto:mrichard.hudson@mixality.com?subject=QA%20Automation%20Audit"
              className="btn btn-primary btn-lg"
            >
              Book a QA Audit
              <ArrowRight size={20} />
            </a>
            <a href="#services" className="btn btn-secondary btn-lg">
              See Services
            </a>
          </motion.div>

          <motion.div
            className="hero-proof"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            <div className="proof-item">
              <span className="proof-value">20+</span>
              <span className="proof-label">Years QA Experience</span>
            </div>
            <div className="proof-divider"></div>
            <div className="proof-item">
              <span className="proof-value">$300</span>
              <span className="proof-label">Audit Starts At</span>
            </div>
            <div className="proof-divider"></div>
            <div className="proof-item">
              <span className="proof-value">1 wk</span>
              <span className="proof-label">Starter Delivery</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
